import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import keymaster from 'keymaster';
import moment from 'moment';
import { sortUsersByName2 } from '../utils/sorting';
import roles from '../utils/roles';

import UserItem from './UserItem';
import OverviewHeader from './OverviewHeader';
import Spinner from './Spinner';

import approvedHourActions from '../actions/approvedHourActionCreators';
import * as logEntryActions from '../actions/logEntryActionCreators';
import timesheetActions from '../actions/timesheetActionCreators';
import userActions from '../actions/userActionCreators';
import Time from "../utils/time";

require.ensure([], () => {
    require('./WeekSheetApproval.less');
});

class StaffOverview extends React.Component {

    constructor(props, context) {
        super(props, context);

        setTimeout(this.loadData, 100);

        this.state = {
            date: moment().day(1),
            filterText: "",
            userOpenID: null
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.currentUser) {
            //way to transition to root using react-router if user has no roles
            if(!roles.userHasAnyOfRoles(nextProps.currentUser, ['LM', 'CM'])) {
                browserHistory.push('/');
            }
        }
    }

    componentDidMount = () => {
        moment.updateLocale('en', {
            week: { doy: 4, dow: 1 }
        });

        keymaster('left', this.decrementWeek);
        keymaster('right', this.incrementWeek);
        this.loadData();
    }

    componentWillUnmount = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    // EVENT HANDLERS

    handleDateChange = (date) => {
        moment.updateLocale('en', {
            week: { doy: 4, dow: 1 }
        });

        if (this.props.loading) return;

        this.setState({
            date: moment(date, "YYYY-MM-DD").startOf('isoweek')
        }, this.loadData);
    }

    handleFilterChange = (event) => {
        this.setState({
            filterText: event.target.value
        });
    }

    handleUserClick = (key) => {
        let userID = this.props.users[key].id;

        this.setState({
            userOpenID: userID === this.state.userOpenID ? null : userID
        }, () => {
            //Callback
            if (this.state.userOpenID) {
                this.props.dispatch(logEntryActions.loadByTimesheetTasks(this.props.users[key].timesheet.id));
                this.props.dispatch(logEntryActions.loadOnWeekForUser(this.state.date, this.props.users[key].id));
            }
        });
    }

    // OTHER METHODS

    clearFilter = () => {
        this.setState({
            filterText: ""
        });
    }

    decrementWeek = () => {
        if (this.props.loading) {
            return;
        }
        this.setState({
            date: this.state.date.subtract(7, 'days'),
            userOpenID: null
        }, this.loadData);
    }

    incrementWeek = () => {
        if (this.props.loading) {
            return;
        }
        this.setState({
            date: this.state.date.add(7, 'days'),
            userOpenID: null
        }, this.loadData);
    }

    loadData = () => {
        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['LM', 'CM'])) {
            let formattedYearAndWeek = Time.getFormattedYearAndWeek(this.state.date);
            this.props.dispatch(userActions.cmlmLoadUsersForStaffOverview(formattedYearAndWeek));
            this.props.dispatch(timesheetActions.cmlmLoadByWeek(formattedYearAndWeek));
            this.props.dispatch(approvedHourActions.cmlmLoadByWeek(formattedYearAndWeek));
            // TODO create backend for loading tms and aph
        }
    }

    // RENDER METHOD

    render = () => {
        const spinnerStyle = {
          margin: "105px"
        };
        let filter = new RegExp(this.state.filterText, 'i');

        if (this.props.users.length === 0 && !this.props.loading) {
            return (
                <div className="container">
                    <br/>
                    <OverviewHeader
                        date={this.state.date}
                        decrementWeek={this.decrementWeek}
                        endDay={this.state.date.clone().add(6, 'days')}
                        handleDateChange={this.handleDateChange}
                        incrementWeek={this.incrementWeek}
                        loading={this.props.loading}
                        startDay={this.state.date}
                        />
                    <br/>
                    <h4 className="text-center">No staff work logged this week</h4>
                </div>
            );
        }

        if(!this.props.loading) {
            return (
                <div className="container">

                    <br/>
                        <OverviewHeader
                            date={this.state.date}
                            decrementWeek={this.decrementWeek}
                            endDay={this.state.date.clone().add(6, 'days')}
                            handleDateChange={this.handleDateChange}
                            incrementWeek={this.incrementWeek}
                            loading={this.props.loading}
                            startDay={this.state.date}
                            />
                    <br/>

                    <div className="panel-filter">
                        <div className="form-group">
                            <label>Filter:</label>
                            <input onChange={this.handleFilterChange} value={this.state.filterText} type="text" className="form-control" placeholder="User Name"/>
                            <a style={{"cursor" : "pointer", paddingRight : "10px", paddingTop : "5px"}} onClick={this.clearFilter} className="filter-clear">
                                <span>
                                    <span className="md-clear"></span>
                                </span>
                            </a>
                        </div>
                    </div>

                    <div className="row project">
                        <div className="col-lg-10 col-lg-offset-1 col-md-12">
                            <div className="panel-group" id="accordion-outer" role="tablist" aria-multiselectable="true">
                            {
                                this.props.users.map((user, key) => {
                                    if (!filter.test(user.givenName) && !filter.test(user.surname)) {
                                        return null;
                                    }
                                    return <UserItem
                                               active={this.state.userOpenID && this.state.userOpenID === user.id}
                                               date={this.state.date}
                                               handleClick={this.handleUserClick}
                                               id={key}
                                               key={key}
                                               user={user}
                                               />;
                                })
                            }
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else return (
                        <div style={spinnerStyle}>
                            <Spinner />
                        </div>
                      );
    }
}

StaffOverview.contextTypes = {
    router: PropTypes.object.isRequired
};

StaffOverview.propTypes = {
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    loading: PropTypes.bool,
    users: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        loading: state.timesheets.loading || state.users.loading,
        users: state.users.cmlmUsersForStaffOverview.sort(sortUsersByName2)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffOverview);



/** WEBPACK FOOTER **
 ** ./src/app/components/StaffOverview.js
 **/